<template>
  <div :class="`col-md-4 ${className ? className : ''}`">
    <div class="input-block mb-3">
      <div class="d-flex align-items-center justify-content-between">
        <label class="col-form-label">{{ label }} <span v-if="!notRequired" class="text-danger">*</span></label>
      </div>
      <Field placeholder="Select Value" v-slot="{ field }" :name="name" v-model="internalValue">
        <multiselect
          v-bind="field"
          v-model="internalValue"
          :options="options"
          :track-by="'value'"
          :label="optionLabel"
          :searchable="true"
          :clear-on-select="false"
          :close-on-select="!multiple"
          :disabled="readOnly"
          :multiple="multiple || false"
          @select="handleChange"
          @remove="handleRemove"
          :loading="loading"
          select-label="Select"
          deselect-label="Remove"
        >
        </multiselect>
      </Field>
      <span v-if="error" class="text-danger">{{ error }}</span>
    </div>
  </div>
</template>

<script>
import { error } from "jquery";
import { Field } from "vee-validate";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Field,
    Multiselect,
  },
  props: [
    "label",
    "name",
    "options",
    "error",
    "value",
    "disabled",
    "className",
    "readOnly",
    "optionLabel",
    "selectedValue",
    "modelValue",
    "notRequired",
    "loading",
    "multiple"
  ],
  emits: ["dropdown-value-change", "update:modelValue", "remove", "dropdown-value-remove"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue; // Use `modelValue` directly
      },
      set(value) {
        this.$emit("update:modelValue", value); // Emit `update:modelValue` for `v-model`
      },
    },
  },
  methods: {
    handleChange(selected) {
      this.internalValue = selected; // Update `internalValue`
      this.$emit("dropdown-value-change", selected); // Emit custom event
    },
    handleRemove() {
      this.$emit("dropdown-value-remove"); // Emit custom event
      this.$emit("remove"); // Emit custom event
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
